"use strict";
/**
 * @license
 * Copyright 2017 Palantir Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TypedReducerBuilderImpl = (function () {
    function TypedReducerBuilderImpl() {
        this.typedHandlers = {};
    }
    TypedReducerBuilderImpl.prototype.withHandler = function (type, handler) {
        return this.withActionHandler(type, function (state, action) {
            return handler(state, action.payload, action.meta);
        });
    };
    TypedReducerBuilderImpl.prototype.withActionHandler = function (type, handler) {
        if (this.typedHandlers[type]) {
            if (process.env.NODE_ENV === "production") {
                // tslint:disable-next-line:no-console
                console.error("Multiple typed reducer handlers specified in typed reducer for type " + type + ". Using newer.");
            }
            else {
                throw new Error("Multiple typed reducer handlers specified in typed reducer for type " + type + ".");
            }
        }
        this.typedHandlers[type] = handler;
        return this;
    };
    TypedReducerBuilderImpl.prototype.withDefaultHandler = function (handler) {
        if (this.defaultHandler) {
            if (process.env.NODE_ENV === "production") {
                // tslint:disable-next-line:no-console
                console.error("Multiple default handlers specified in typed reducer. Using newer.");
            }
            else {
                throw new Error("Multiple default handlers specified in typed reducer.");
            }
        }
        this.defaultHandler = handler;
        return this;
    };
    TypedReducerBuilderImpl.prototype.build = function () {
        var defaultHandler = this.defaultHandler || (function (state) { return state; });
        return new TypedReducerImpl(tslib_1.__assign({}, this.typedHandlers), defaultHandler).reduce;
    };
    return TypedReducerBuilderImpl;
}());
exports.TypedReducerBuilderImpl = TypedReducerBuilderImpl;
var TypedReducerImpl = (function () {
    function TypedReducerImpl(typedHandlers, defaultHandler) {
        var _this = this;
        this.reduce = function (state, action) {
            var typedHandler = _this.typedHandlers[action.type];
            if (typedHandler) {
                return typedHandler(state, action);
            }
            else {
                return _this.defaultHandler(state, action);
            }
        };
        this.typedHandlers = typedHandlers;
        this.defaultHandler = defaultHandler;
    }
    return TypedReducerImpl;
}());



//////////////////
// WEBPACK FOOTER
// ./node_modules/redoodle/lib/internal/TypedReducerBuilderImpl.js
// module id = 250
// module chunks = 0